// extracted by mini-css-extract-plugin
export default {"customer":"Customer_customer__LCTD8","input":"Customer_input__+GY8c","button":"Customer_button__3Xr6Q"};